import { render, staticRenderFns } from "./InviteStartup.vue?vue&type=template&id=c9b631c0&scoped=true&"
import script from "./InviteStartup.vue?vue&type=script&lang=js&"
export * from "./InviteStartup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9b631c0",
  null
  
)

export default component.exports